const educationalResources = {
  Title: "Educational resources",
  Content:
    "At Emerson Ecologics, a Fullscript company, we want to support your clinical and business success - that's why we're excited to provide a suite of educational resources full of industry-leading news, tips, and information.",
  Protocols: "Protocols",
  ProtocolsContent:
    "Evidence-informed plans that practitioners can use as a foundation for individualized care.",
  PatientResources: "Patient resources",
  PatientResourcesContent:
    "Help your patients play an active role in their health with ready-made, evidence-based resources.",
  LearnMore: "Learn more",
};

export { educationalResources };
